import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { advertisement, ServiceService } from '../../service.service';

/* Componente de formulario */
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

/* Importación de constantes */
import * as constants from '../../constants/general';

/* Importación de providers */
import { UtilsService } from '../../utils.service';

@Component({
  selector: 'app-brocas',
  templateUrl: './brocas.page.html',
  styleUrls: ['./brocas.page.scss', '../../../assets/scss/styles.scss'],
})
export class BrocasPage implements OnInit {

  tmm: number;
  tmp: number;

  /* Lists */
  public materialCutList = [];
  public drillList = constants.DRILL_LIST;
  private brocasListM = [];
  private brocasListP = [];

  /* Variables encargadas del almacenamiento del formulario */
  public brocasForm      : FormGroup = null;
  public bitMaterial     : AbstractControl;
  public materialToBeCut : AbstractControl;
  public vcM             : AbstractControl;
  public vcP             : AbstractControl;
  public diametroM       : AbstractControl;
  public diametroP       : AbstractControl;
  public profundityM     : AbstractControl;
  public profundityP     : AbstractControl;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  /* Constantes */
  private pi = constants.PI;

  /* Outputs */
  private pbM       : number;
  private pbP       : number;
  public pbMTmp     : number;
  public pbPTmp     : number;
  public rpmMM      : number;
  public rpmFt      : number;
  public progressMM : number;
  public progressFt : number;
  public timeMM     : number;
  public timeFt     : number;
  private diameterMmTmp : number;
  private diameterFtTmp : number;

  /* Outputs  */
  previousRpmMM:number;
  previousProgressMM:number;
  previousTimeMM:number;
  previousRpmFt:number;
  previousProgressFt:number;
  previousTimeFt:number;

  constructor( private router: Router,
               private services: ServiceService, 
               private form: FormBuilder,
               private _utils: UtilsService ) {

    //
    this.brocasForm = this.form.group({
      bitMaterial     : ['', Validators.required],
      materialToBeCut : ['', Validators.required],
      vcM             : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      vcP             : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      diametroM       : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      diametroP       : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      profundityM     : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
      profundityP     : ['', Validators.compose( [Validators.required, Validators.pattern('^[0-9]*[\.0-9]{1,5}') ] ) ],
    });

    this.bitMaterial     = this.brocasForm.controls.bitMaterial;
    this.materialToBeCut = this.brocasForm.controls.materialToBeCut;
    this.vcM             = this.brocasForm.controls.vcM;
    this.vcP             = this.brocasForm.controls.vcP;
    this.diametroM       = this.brocasForm.controls.diametroM;
    this.diametroP       = this.brocasForm.controls.diametroP;
    this.profundityM     = this.brocasForm.controls.profundityM;
    this.profundityP     = this.brocasForm.controls.profundityP;
  }

  async ngOnInit() {
    this.getListMaterials();
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(8);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  private getListMaterials() {
    this.services.getJsonOption('brocas').subscribe( res => {
      try {
        this.materialCutList = res[0].elements.materiales;
        this.brocasListM = res[0].elements.brocas_m;
        this.brocasListP = res[0].elements.brocas_p;
      } catch(err) {
        console.error(err);
      }
    });
  }


  public onSelectMaterials() {

    if ( this.bitMaterial.value === 1 ) {
      this.vcM.setValue(this.materialToBeCut.value.m_min);
      this.vcP.setValue(this.materialToBeCut.value.ft_min);
    } else if ( this.bitMaterial.value === 2 ) {
      this.vcM.setValue(this.materialToBeCut.value.cm_min);
      this.vcP.setValue(this.materialToBeCut.value.cft_min);
    }

  }


  public onGetDiameterMM() {

    for ( let i  in this.brocasListM ) {
      const index = parseInt(i);
      console.log(this.brocasListM[index]);

      if ( parseFloat(this.diametroM.value) === parseFloat(this.brocasListM[index].diametro) ) {
        this.pbM = parseFloat(this.brocasListM[index].avance);
        this.pbMTmp = this._utils.roundDecimals(this.brocasListM[index].avance,3);
        break;
      } else {
        let indexMas = index + 1;
        let indexMenos = index - 1;

        if ( index < this.brocasListM.length ) {
          if ( index !== 0 ) {
            
            if ( (parseFloat(this.diametroM.value) > parseFloat(this.brocasListM[indexMenos].diametro)) 
            && ( parseFloat(this.diametroM.value) < parseFloat(this.brocasListM[index].diametro) ) ) {
              this.pbM = parseFloat(this.brocasListM[indexMenos].avance);
              this.pbMTmp = this._utils.roundDecimals(this.brocasListM[indexMenos].avance,3);
              break;
            } else if ( (parseFloat(this.diametroM.value) > parseFloat(this.brocasListM[index].diametro))
            && ( parseFloat(this.diametroM.value) < parseFloat(this.brocasListM[indexMas].diametro) ) ) {
              this.pbM = parseFloat(this.brocasListM[index].avance);
              this.pbMTmp = this._utils.roundDecimals(this.brocasListM[index].avance,3);
              break;
            }
          }
        } else {
          this.pbM = parseFloat(this.brocasListM[index].avance);
          this.pbMTmp = this._utils.roundDecimals(this.brocasListM[index].avance,3);
          break;
        }

      }
    }
    console.log(this.pbM);
  }

  public onGetDiameterFt() {
    for ( let i  in this.brocasListP ) {
      const index = parseInt(i);
      if ( parseFloat(this.diametroP.value) === parseFloat(this.brocasListP[i].diametro) ) {
        this.pbP = parseFloat(this.brocasListP[i].avance);
        this.pbPTmp = this._utils.roundDecimals(this.brocasListP[i].avance,4);
        break;
      } else {
        let indexMas = index + 1;
        let indexMenos = index - 1;

        if ( index < this.brocasListP.length ) {
          if ( index !== 0 ) {
            
            if ( (parseFloat(this.diametroP.value) > parseFloat(this.brocasListP[indexMenos].diametro)) 
            && ( parseFloat(this.diametroP.value) < parseFloat(this.brocasListP[index].diametro) ) ) {
              this.pbP = parseFloat(this.brocasListP[indexMenos].avance);
              this.pbPTmp = this._utils.roundDecimals(this.brocasListP[indexMenos].avance,4);
              break;
            } else if ( (parseFloat(this.diametroP.value) > parseFloat(this.brocasListP[index].diametro))
            && ( parseFloat(this.diametroP.value) < parseFloat(this.brocasListP[indexMas].diametro) ) ) {
              this.pbP = parseFloat(this.brocasListP[index].avance);
              this.pbPTmp = this._utils.roundDecimals(this.brocasListP[index].avance,4);
              break;
            }
          }
        } else {
          this.pbP = parseFloat(this.brocasListP[index].avance);
          this.pbPTmp = this._utils.roundDecimals(this.brocasListP[index].avance,4);
          break;
        }

      }
    }
    console.log(this.pbP);
  }

  isSharing:boolean = false;
  public calcular() {
    let multSpeedMM: number;
    let multDiameterMM: number;
    let multSpeedFt: number;
    let multDiameterFt: number;

    if ( this.diametroM.valid && this.profundityM.valid ) {

      multSpeedMM = parseFloat(this.vcM.value) * 1000;
      multDiameterMM = this.pi * parseFloat(this.diametroM.value);

      // Calculo de RPM
      this.rpmMM = this._utils.roundDecimals( (multSpeedMM / multDiameterMM), 0 );

      // Calculo Avance recomendado
      const progressTmp = +(this.rpmMM * this.pbM);
      this.progressMM = this._utils.roundDecimals(progressTmp, 1);

      // Calculo de tiempo
      const timmeTmp = +( (parseFloat(this.profundityM.value) * 60 ) / this.progressMM )
      this.timeMM = this._utils.roundDecimals(timmeTmp, 1);
    } else {
      multSpeedMM = 0;
      multDiameterMM = 0;
      this.rpmMM = 0;
      this.progressMM = 0;
      this.timeMM = 0;
    }
    
    if ( this.diametroP.valid && this.profundityP.valid ) {

      multSpeedFt = parseFloat(this.vcP.value) * 12;
      multDiameterFt = this.pi * parseFloat(this.diametroP.value);

      // Calculo de RPM
      this.rpmFt = this._utils.roundDecimals(multSpeedFt / multDiameterFt, 0 );
      // Calculo Avance recomendado
      const progressTmp = +this._utils.roundDecimals( ((multSpeedFt / multDiameterFt) * this.pbP), 4);
      this.progressFt = this._utils.roundDecimals(progressTmp, 1);
      // Calculo de tiempo
      const timmeTmp = +( (parseFloat(this.profundityP.value) * 60 ) / this.progressFt );
      this.timeFt = this._utils.roundDecimals(timmeTmp, 1);
    } else {
      multSpeedFt = 0;
      multDiameterFt = 0;
      this.rpmFt = 0;
      this.progressFt = 0;
      this.timeFt = 0;
    }
    if((this.rpmMM != this.previousRpmMM || this.rpmFt != this.previousRpmFt || this.progressMM != this.previousProgressMM || this.progressFt != this.previousProgressFt || this.timeMM != this.previousTimeMM || this.timeFt != this.previousTimeFt) && !this.isSharing){
      this.previousRpmMM = this.rpmMM;
      this.previousRpmFt = this.rpmFt;
      this.previousProgressMM = this.progressMM;
      this.previousProgressFt = this.progressFt;
      this.previousTimeMM = this.timeMM;
      this.previousTimeFt = this.timeFt;
      this.isSharing = true;
      setTimeout(()=>{ this.isSharing = false; },20000);
      this.services.addPointCalculator();
    }
  }


  home() {
    return this.router.navigate(['/calculadora']);
  }

}
